import { ChevronRight, Ticket } from "lucide-react";

/** Linha "Tem um cupom?" do resumo da sacola: abre a janela de cupons da loja. */
export default function CupomDaSacola({ t, codigo, quantidade, onClick }) {
  return (
    <button type="button" onClick={onClick} data-e2e="sacola-lateral-cupom"
      className={`w-full flex items-center gap-3 rounded-xl border ${t.border} px-3 py-2.5 text-left hover:border-orange-500/50 transition-colors`}>
      <Ticket className={`w-5 h-5 shrink-0 ${codigo ? "text-emerald-500" : "text-orange-500"}`} />
      <span className="min-w-0 flex-1">
        <span className={`block text-sm font-semibold leading-tight ${t.text}`}>{codigo ? `Cupom ${codigo}` : "Tem um cupom?"}</span>
        <span className={`block text-xs leading-tight mt-0.5 ${t.textMuted}`}>
          {codigo ? "Toque para trocar ou tirar" : `Escolha entre ${quantidade === 1 ? "o cupom" : `os ${quantidade} cupons`} da loja`}
        </span>
      </span>
      <ChevronRight className={`w-4 h-4 shrink-0 ${t.textMuted}`} />
    </button>
  );
}
